module.exports = {"data":{"site":{"siteMetadata":{"title":"Grecian Isle"}}},"layoutContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/layout-index.json
// module id = 124
// module chunks = 60335399758886 79611799117203